import { jsx, jsxs } from "react/jsx-runtime";
import { cn } from "../../../lib/utils.js";
import "../shared/quiz-blank.js";
import { KatexText } from "../shared/katex-text.js";
import "react";
import "react-i18next";
import "../../../node_modules/.pnpm/hls.js@1.6.15/node_modules/hls.js/dist/hls.js";
import { countBlanks, formatProblem } from "../../../utils/quiz-parser.js";
import "../../../context/DevToolsContext.js";
import { getImageUrl, getPrintScale, getStyles, PrintQuizTitle, PrintQuizImage } from "./print-common.js";
function FillBlankPrint({
  quizId,
  quiz,
  number,
  showCorrectAnswers = false,
  correctAnswers,
  compact
}) {
  const s = getStyles(compact);
  const imageUrl = getImageUrl(quiz.image, quiz.imagePrint);
  const printScale = getPrintScale(quiz.image, quiz.imagePrint);
  const blankCount = countBlanks(quiz.problem);
  const renderedProblem = blankCount > 0 ? formatProblem(
    quiz.problem,
    `${quizId}-print-problem`,
    (index) => {
      const answer = correctAnswers == null ? void 0 : correctAnswers[index];
      const showAnswer = showCorrectAnswers && answer;
      return /* @__PURE__ */ jsx(
        "span",
        {
          className: cn(
            s.inputBoxLg,
            "inline-flex items-center justify-center px-[8px] align-middle text-[16px]",
            compact ? "mx-[8px] my-[4px]" : "mx-[12px]",
            showAnswer ? "text-gray-500 font-medium" : ""
          ),
          children: showAnswer ? /* @__PURE__ */ jsx(KatexText, { text: answer }) : " "
        },
        `blank-print-${quizId}-${index}`
      );
    },
    quiz.additionalImages ?? void 0
  ) : [];
  return /* @__PURE__ */ jsxs("div", { className: cn(s.container, s.quizSection), children: [
    /* @__PURE__ */ jsx(PrintQuizTitle, { number, compact, children: /* @__PURE__ */ jsx(KatexText, { text: quiz.title }) }),
    imageUrl && /* @__PURE__ */ jsx(PrintQuizImage, { src: imageUrl, printScale }),
    blankCount > 0 && /* @__PURE__ */ jsx("div", { className: s.problemArea, children: /* @__PURE__ */ jsx("div", { className: cn(
      s.problemLine,
      compact ? "text-[15px] text-black tracking-[-0.09px] font-normal leading-[41px]" : s.problemText
    ), children: renderedProblem }) })
  ] });
}
export {
  FillBlankPrint
};
//# sourceMappingURL=fill-blank-print.js.map
